import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import Svg, { Defs, RadialGradient, Rect, Stop } from 'react-native-svg';

export const ProfileBackground = ({ children }: { children: React.ReactNode }) => {
  return (
    <View style={styles.container}>
      <View style={styles.background}>
        <Svg width="100%" height="100%">
          <Defs>
            <RadialGradient id="grad1" cx="-10%" cy="-10%" rx="120%" ry="120%">
              <Stop offset="0%" stopColor="#3B5BDB" stopOpacity="0.35" />
              <Stop offset="100%" stopColor="#3B5BDB" stopOpacity="0" />
            </RadialGradient>

            <RadialGradient id="grad2" cx="110%" cy="110%" rx="120%" ry="120%">
              <Stop offset="0%" stopColor="#7B3FE4" stopOpacity="0.35" />
              <Stop offset="100%" stopColor="#7B3FE4" stopOpacity="0" />
            </RadialGradient>
          </Defs>

          <Rect width="100%" height="100%" fill="#16153A" />

          <Rect width="100%" height="100%" fill="url(#grad1)" />
          <Rect width="100%" height="100%" fill="url(#grad2)" />
        </Svg>
      </View>
      <ScrollView contentContainerStyle={styles.content} showsVerticalScrollIndicator={false}>
        {children}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    minHeight: '100%',
    flexGrow: 1,
  },
  background: {
    ...StyleSheet.absoluteFillObject,
  },
  content: {
    flexGrow: 1,
    paddingBottom: 40,
  },
});
